class MobileDock extends HTMLElement {
  constructor() {
    super();
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.hideStickyHeaderHandler = this.hideStickyHeader.bind(this);
    this.updateDockMetricsHandler = this.updateDockMetrics.bind(this);
    this.syncWithStickyCartHandler = this.syncWithStickyCart.bind(this);
  }

  connectedCallback() {
    this.isAction = false;
    this.classList.add('is-active');

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClickHandler);
    });
    document.addEventListener('menudrawer:close', this.hideStickyHeaderHandler);
    document.addEventListener('searchmodal:close', this.hideStickyHeaderHandler);
    document.addEventListener('matchSmall', this.updateDockMetricsHandler);
    window.addEventListener('resize', this.updateDockMetricsHandler, { passive: true });

    this.stickyCartObserver = new MutationObserver(this.syncWithStickyCartHandler);
    if (document.body) {
      this.stickyCartObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['animate'],
        childList: true,
        subtree: true
      });
    }

    this.syncWithStickyCart();
  }

  disconnectedCallback() {
    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.removeEventListener('click', this.onButtonClickHandler);
    });
    document.removeEventListener('menudrawer:close', this.hideStickyHeaderHandler);
    document.removeEventListener('searchmodal:close', this.hideStickyHeaderHandler);
    document.removeEventListener('matchSmall', this.updateDockMetricsHandler);
    window.removeEventListener('resize', this.updateDockMetricsHandler);
    this.stickyCartObserver?.disconnect();
  }

  updateDockMetrics() {
    const dockHeight = this.classList.contains('is-suppressed') ? 0 : this.offsetHeight;
    document.documentElement.style.setProperty('--mobile-dock-height', `${dockHeight}px`);
  }

  syncWithStickyCart() {
    const stickyCartIsActive = document.body?.classList.contains('template-product')
      && document.querySelector('animate-sticky[animate]') !== null;

    this.classList.toggle('is-suppressed', stickyCartIsActive);
    this.updateDockMetrics();
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = this.waitStickyHeader();

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const miniCart = document.querySelector('mini-cart');
        if (miniCart) {
          setTimeout(() => {
            miniCart.open();
            document.activeElement.blur();
          }, delay);
        }
        else {
          window.location.href = theme.routes.cart_url;
        }
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawer = document.querySelector('header-drawer');
        if (headerDrawer) {
          setTimeout(() => {
            headerDrawer.openMenuDrawer();
          }, delay);
        }
        break;

      case 'search':
        this.isAction = true;
        
        const searchModals = document.querySelectorAll('search-modal');
        if (searchModals.length > 0) {
          searchModals.forEach((searchModal) => {
            const style = window.getComputedStyle(searchModal);
            if (style.display === 'none') {
              return;
            }
  
            setTimeout(() => {
              searchModal.open();
              searchModal.querySelector('input:not([type="hidden"])').focus();
            }, delay);
          });
        }
        else {
          window.location.href = theme.routes.search_url;
        }
        break;
    }
  }

  hideStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (theme.config.mqlSmall && this.isAction && header.sticky()) {
      setTimeout(() => {
        header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  waitStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (!header.sticky() && !this.isElementVisible(header)) {
      header.hide();
      setTimeout(() => header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    // Return true if any of its four corners are visible
    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
customElements.define('mobile-dock', MobileDock);
